<template>
  <v-card>
    <v-snackbar v-model="snackbar" :color="color.snackbar" top="top">
      {{ message }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-dialog v-model="dialog.Tiket" persistent max-width="800px">
      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>Detail Tiket User</v-toolbar-title>

          <div class="flex-grow-1"></div>

          <v-btn icon @click="dialog.Tiket = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <TabTiket :id_app_user="MitraInfo.id" />

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" dark @click="dialog.Tiket = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.Edit" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span>Daftar Verifikasi KTP</span>
        </v-card-title>

        <v-card-text >
          <v-container>
            <v-row>
              <v-col cols="12" sm="6">
                <v-list-item-subtitle class="grey--text">
                  Nama Profil
                </v-list-item-subtitle>

                <v-list-item-title class="headline2 mb-1 black--text" style="text-wrap: wrap;">
                  {{ DetailMitra.nama }}
                </v-list-item-title>
              </v-col>

              <v-col cols="12" sm="6">
                <v-list-item-subtitle class="grey--text">
                  No. HP
                </v-list-item-subtitle>

                <v-list-item-title class="headline2 mb-1 black--text">
                  {{ DetailMitra.nomor_hp }}
                </v-list-item-title>
              </v-col>

              <v-col cols="12" sm="6">
                <v-list-item-subtitle class="grey--text">
                  Nama Sesuai KTP
                </v-list-item-subtitle>

                <v-list-item-title class="headline2 mb-1 black--text" style="text-wrap: wrap;">
                  {{ ListVerifikasi.nama_ktp }}
                </v-list-item-title>
              </v-col>

              <v-col cols="12" sm="6">
                <v-list-item-subtitle class="grey--text">
                  No. KTP
                </v-list-item-subtitle>

                <v-list-item-title class="headline2 mb-1 black--text" style="text-wrap: wrap;">
                  {{ ListVerifikasi.no_ktp }}
                </v-list-item-title>
              </v-col>
              <v-col cols="12" sm="6">
                <v-list-item-subtitle class="grey--text">
                  Status:
                </v-list-item-subtitle>

                <v-list-item-title class="headline2 mb-1 blue--text">
                  {{ ListVerifikasi.status_dokumen_ktp }}
                </v-list-item-title>
              </v-col>
            </v-row>

            <v-row v-if="ListVerifikasi.foto_ktp !== null">
              <v-card-title> Foto KTP </v-card-title>
              <viewer :images="images">
                <v-col cols="12" sm="12">
                  <img
                    :src="$url_img + ListVerifikasi.foto_ktp"
                    width="150"
                    height="150"
                  />
                </v-col>
              </viewer>
            </v-row>
            <v-row v-if="ListVerifikasi.swafoto !== null">
              <v-card-title> SwaFoto </v-card-title>
              <viewer :images="images">
                <v-col cols="12" sm="12">
                  <img
                    :src="$url_img + ListVerifikasi.swafoto"
                    width="150"
                    height="150"
                  />
                </v-col>
              </viewer>
            </v-row>
          </v-container>

          <small>*Pastikan Foto KTP dan SwaFoto sesuai. </small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text dark @click="dialog.Edit = false">
            Close
          </v-btn>

          <v-btn color="red darken-1" dark @click="dialog.Tolak = true">
            Tolak
          </v-btn>

          <v-btn color="blue darken-1" dark @click="dialog.Terima = true">
            Terima
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.Tolak" persistent max-width="500px">
      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>Tolak Verifikasi</v-toolbar-title>

          <div class="flex-grow-1"></div>

          <v-btn icon @click="dialog.Tolak = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <!-- <v-select
          :items="MstStatusTolak"
          v-model="Alasan"
          item-text="alasan"
          item-value="alasan"
          label="Alasan Tolak Moderasi (Wajib Dipilih)"
          solo
        ></v-select> -->

        <v-card-text>
          <v-textarea v-model="Alasan" label="Alasan Menolak"></v-textarea>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn color="red darken-1" dark @click="dialog.Tolak = false">
            Batalkan
          </v-btn>

          <v-btn color="blue darken-1" dark @click="OnTolak"> Tolak </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.Terima" persistent max-width="500px">
      <v-card>
        <v-toolbar dense>
          <v-toolbar-title>Terima Verifikasi KTP?</v-toolbar-title>

          <div class="flex-grow-1"></div>

          <v-btn icon @click="dialog.Terima = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-title>
          Apakah Anda Yakin Foto KTP dan Swafoto sudah sesuai?
        </v-card-title>

        <v-card-actions>
          <div class="flex-grow-1"></div>

          <v-btn color="red darken-1" dark @click="dialog.Terima = false">
            Batalkan
          </v-btn>

          <v-btn color="blue darken-1" dark @click="OnKonfirmasi">
            Terima
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" sm="12">
        <v-text-field
          solo
          label="Search"
          clearable
          prepend-inner-icon="search"
          @keyup.enter="GetListMitra"
          @click:clear="doClear"
          v-model="keyword"
        ></v-text-field>
      </v-col>
    </v-row>

    <div class="text-center pt-2">
      <v-pagination
        v-model="page"
        @input="GetListMitra()"
        :length="lengthPage"
        :total-visible="7"
      ></v-pagination>
    </div>

    <v-row>
      <v-col v-for="item in ListMitra.data" :key="item.id" cols="12" md="3">
        <ListVerifikasi
          v-if="RenderUnits"
          :item="item"
          :onDetail="GetDetailMitra"
        />
      </v-col>
    </v-row>
    <div align="center" v-if="ListVerifikasi.length < 0">
      <v-alert dense outlined type="error">
        <strong> Yahhhh! </strong> Belum ada pengajuan verifikasi :(
      </v-alert>
    </div>
  </v-card>
</template>
<script>
import ListVerifikasi from '@/components/ListVerifikasi.vue';
import TabTiket from '@/components/TabTiket.vue';
import 'viewerjs/dist/viewer.css';
import Viewer from 'v-viewer';
import Vue from 'vue';
Vue.use(Viewer);

export default {
  components: {
    ListVerifikasi,
    TabTiket,
  },
  data() {
    return {
      response: null,
      RenderUnits: true,
      color: { snackbar: '' },
      snackbar: false,
      Selected_UserType: null,
      message: null,
      UserStatus: [],
      dialog: { Edit: false, Tolak: false, Terima: false },
      ListVerifikasi: [],
      MitraInfo: [],
      // MstStatusTolak: [],
      keyword: '',
      page: 1,
      images: [],
      lengthPage: 0,
      limit: 16,
      offset: 0,
      total: 0,
      users: [],
      ListMitra: [],
      Alasan: '',
    };
  },
  created() {
    let users = localStorage.getItem('user');
    this.users = JSON.parse(users);
    this.GetListMitra();
  },
  methods: {
    async handleClickStatus() {
      await this.GetListMitra(this.Selected_UserType);
      this.forceRerender();
    },
    forceRerender() {
      this.RenderUnits = false;
      this.$nextTick(() => {
        this.RenderUnits = true;
      });
    },
    async Reload() {
      this.GetListMitra();
      this.forceRerender();
    },
    doClear() {
      var params = new URLSearchParams();
      params.append('search', '');
      params.append('limit', 999);

      var request = {
        params: params,
      };

      this.$req
        .get(this.$root.$baseapi.user+'/user/v3/user', request)
        .then((response) => {
          let { data } = response.data;
          this.ListMitra = data;
        })
        .catch((error) => {
          let { responses } = error;
          console.log(responses);
        });
    },
    go() {
      var offset = (this.offset = (this.page - 1) * this.limit);
      console.log(offset);
    },
    async GetListMitra() {
      var offset = (this.page - 1) * this.limit;

      await this.$req
        .get(this.$root.$baseapi.user+'/user/v3/user', {
          params: {
            search: this.keyword,
            id_biz_user: this.users.id,
            id_mst_verifikasi_dokumen_ktp: 2,
            offset: offset,
            limit: this.limit,
          },
        })
        .then((response) => {
          this.ListMitra = response.data;
          var mod = this.ListMitra.count;
          this.lengthPage = Math.ceil(mod / this.limit);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async GetVerifikasiKTP(id) {
      await this.$req
        .get(this.$root.$baseapi.user+'/user/v3/user/verifikasi_ktp_pengguna', {
          params: {
            limit: this.limit,
            id_app_user: id,
          },
        })
        .then((response) => {
          let { data } = response.data;
          this.ListVerifikasi = data[0];
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async GetDetailMitra(id) {
      const mitra = await this.$req.get(this.$root.$baseapi.user+'/user/v3/user', {
        params: {
          id: id,
          limit: 1,
        },
      });
      this.GetVerifikasiKTP(id);
      this.MitraInfo = mitra.data.data[0];
      this.dialog.Edit = true;
    },

    async OnTolak() {
      let formData = new FormData();
      formData.append('id_app_user', this.MitraInfo.id);
      formData.append('id_biz_user', this.users.id);
      formData.append('deskripsi', this.Alasan);

      const response = await this.$req.post(
        this.$root.$baseapi.user+'/user/v3/user/decl_ktp_pengguna',
        formData
      );
      this.dialog.Detail = false;
      this.dialog.Tolak = false;
      this.snackbar = true;
      this.message = response.data.api_message;
      this.color.snackbar = 'success';
      this.Reload();
    },

    async OnKonfirmasi() {
      let formData = new FormData();
      formData.append('id_app_user', this.MitraInfo.id);
      formData.append('id_biz_user', this.users.id);
      formData.append('deskripsi', 'Verifikasi KTP Berhasil');
      await this.$req
        .post(this.$root.$baseapi.user+'/user/v3/user/confirm_ktp_pengguna', formData)
        .then(response => {
          this.dialog.Detail = false;
          this.dialog.Terima = false;
          this.snackbar = true;
          this.message = response.data.api_message;
          this.color.snackbar = 'success';
          this.Reload();
        })
        .catch(error => {
          let responses = error.response.data
          this.snackbar = true;
          this.message = responses.api_message;
          this.color.snackbar = 'error';
          console.log(responses);
        });
    },
  },
  computed: {
    DetailMitra() {
      return this.MitraInfo;
    },

    ComUserStatus: {
      get: function () {
        return this.MitraInfo.id_mst_user_status;
      },
      // setter
      set: function (newValue) {
        this.MitraInfo.id_mst_user_status = newValue;
      },
    },
  },
};
</script>
